import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, debounceTime, distinctUntilChanged, filter, finalize, map, of, Subscription, switchMap, take } from 'rxjs';
import { DocumentoComprovacaoService } from 'src/app/modules/services/documento-comprovacao/documento-comprovacao.service';
import { PageSizeService } from 'src/app/modules/services/page-size/page-size.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import { FormatUtilsService } from 'src/app/modules/services/format-utils/format-utils.service';
import { AfericaoServicoInicialService } from 'src/app/modules/shared/afericao-servico-Inicial/afericao-servico-inicial.service';
import { AfericaoRelatorioService } from 'src/app/modules/services/afericao-relatorio/afericao-relatorio.service';
import { ModalVincularRelatorioComponent } from 'src/app/modules/shared/modals/modal-vincular-relatorio/modal-vincular-relatorio.component';
import { AfericaoOperacionalService } from 'src/app/modules/services/afericao-operacional/afericao-operacional.service';
import { AfericaoAmpliacaoService } from 'src/app/modules/services/afericao-ampliacao/afericao-ampliacao.service';
import { AlertComponent } from 'src/app/modules/components/alert/alert.component';
import { LoadingService } from 'src/app/modules/components/loading/loading.service';
import { ModalComponent } from 'src/app/modules/components/modal/modal.component';
import { AuthService } from 'src/app/modules/services/auth/auth.service';
import { UserService } from 'src/app/modules/services/user/user.service';


interface UploadedFile {
  file: File;
  url: SafeUrl;
  isImage: boolean;
}
@Component({
  selector: 'app-documento-comprovacao',
  templateUrl: './documento-comprovacao.component.html',
  styleUrls: ['./documento-comprovacao.component.scss']
})
export class DocumentoComprovacaoComponent implements OnInit {
  private readonly VALID_EXTENSIONS = [
        'pdf', 'doc', 'docx', 'txt', 'odt', 'xlsx', 'xls', 'csv', 'ods',
        'ppt', 'pptx', 'odp', 'jpeg', 'jpg', 'png', 'zip', 'rar', 'html', 'htm'
    ];
  comentario: string = '';
  protocolo: string = '';
  status: 'pending' | 'approved' | 'rejected' = 'pending';
  files: UploadedFile[] = [];
  imageIndex = 0;
  imagens: any[] = [];
  arquivos: string[] = [];
  comentarios = ``;
  firstLine: any = [];
  secondtLine: any = [];
  documentsForView: any = [];
  columnConfig = [
    { columnDef: 'nome', header: 'Nome', property: 'user.nome' },
    { columnDef: 'cargo', header: 'Cargo', property: 'cargo.nome' },
    { columnDef: 'tipoEntidade', header: 'Tipo de entidade', property: 'companies.tipoEntidade.nome' },
    { columnDef: 'actions', header: 'Ações', custom: true }
  ];
  sortState = {
    sortProperty: 'user.nome',
    sortDirection: 'asc'
  };
  buttonExclusaoDisabled: boolean = false;
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = [];
  pageIndex: number = 0;
  pageSize: number = 10;
  totalPages: number = 1;
  totalElements: number = 0;
  subsctiptions: Subscription[] = [];
  screenWidth: number = window.innerWidth;
  searchControl = new FormControl('');
  selectedOption: any;
  filteredOptions: any[] = [];
  idEntidade: any;
  idAfericao: any;
  entitie: any;
  afericao: any;
  filesAdded: {
    nomeArquivo: string;
    tipoMime: string;
    categoria: string;
    subCategoria: string;
    objetoOriginal: File;
  }[] = [];
  transicaoId!: string;
  transicaoNome: any;
  idStatusAtual!: string;
  from: any;
  relatoriosVinculados: any = [];
  subscriptions: Subscription[] = [];
  private imagePageIndex = 0;
  private readonly imagesPerPage = 8; // 4 por linha × 2 linhas
  private documentPageIndex = 0;
  private readonly documentsPerPage = 4;
  isUserAssign:boolean = false
  idUserAssign:string = ''
  constructor(
    private sanitizer: DomSanitizer,
    private pageSizeService: PageSizeService,
    private documentoComprovacaoService: DocumentoComprovacaoService,
    private afericaoServicoInicialService: AfericaoServicoInicialService,
    public toastService: ToastService,
    private route: ActivatedRoute,
    private router: Router,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private loadingService: LoadingService,
    private formatUtilsService: FormatUtilsService,
    private afericaoRelatorioService: AfericaoRelatorioService,
    private afericaoOperacionalService: AfericaoOperacionalService,
    private afericaoAmpliacaoService: AfericaoAmpliacaoService,
    private authService: AuthService,
     private userService: UserService,
  ) { }
  ngOnInit(): void {
    this.route.paramMap.subscribe((params: any) => {
      this.idEntidade = params.get('idEntidade');
      this.idAfericao = params.get('idAfericao');
      this.transicaoId = params.get('transicaoId');
      this.idStatusAtual = params.get('idStatusAtual');
      this.transicaoNome = params.get('transicaoNome');
      this.from = params.get('from');
      if (this.from == 'afericao-inicial') {
        this.getAfericao(this.idAfericao);
      } else if(this.from == 'afericao-relatorio'){
        this.getAfericaoRelatorio(this.idAfericao);
      }else if(this.from == 'afericao-operacional'){
           this.getAfericaoOperacional(this.idAfericao);
      }else if(this.from == 'afericao-ampliacao'){
           this.getAfericaoAmpliacao(this.idAfericao);
      }

      this.getEntity(this.idEntidade);
    });
    this.displayedColumns = this.columnConfig.map(col => col.columnDef);


  this.searchControl.valueChanges.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    filter(value => typeof value === 'string' && value.trim().length > 0),
   map(value => {
    const valueWithoutAccents = (value as string).normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    return valueWithoutAccents.toLowerCase().trim();
}),
    switchMap(value =>
        this.documentoComprovacaoService.getUsuariosAssinantes(this.idEntidade, value, '').pipe(
            catchError(() => of([]))
        )
    )
).subscribe((results: any) => {
    this.filteredOptions = results.content || [];
});
  }
    loadUserInfo() {
    const userId:any = this.authService.getUserIdFromToken();
     this.userService.getMenuUsuario(userId).pipe(take(1)).subscribe((response: any) => {
        this.documentoComprovacaoService.getUsuariosAssinantes(this.idEntidade, '', '', response.id).pipe(take(1))
          .subscribe((valor: any) => {
            this.selectedOption = valor.content.find((user: any) => user.user.id == response.id);
            this.idUserAssign = this.selectedOption.id;
            this.addUser();
            this.isUserAssign = true;
          });
     })
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  getAfericao(id: string) {
    this.loadingService.showLoading();
    this.subsctiptions.push(
      this.afericaoServicoInicialService
        .getAfericaoInicial(id)
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          })
        )
        .subscribe({
          next: (response: any) => {
            this.afericao = response;
          },
          error: (erro: any) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          },
        })
    );
  }
  getAfericaoRelatorio(id: string) {
    this.loadingService.showLoading();
    this.subsctiptions.push(
      this.afericaoRelatorioService
        .getAfericaoRelatorio(id)
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          })
        )
        .subscribe({
          next: (response: any) => {
            this.afericao = response;
          },
          error: (erro: any) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          },
        })
    );
  }
    getAfericaoOperacional(id: string) {
    this.loadingService.showLoading();
    this.subsctiptions.push(
      this.afericaoOperacionalService
        .getAfericaoOperacional(id)
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          })
        )
        .subscribe({
          next: (response: any) => {
            this.afericao = response;
          },
          error: (erro: any) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          },
        })
    );
  }
  getAfericaoAmpliacao(id: string) {
    this.loadingService.showLoading();
    this.subsctiptions.push(
      this.afericaoAmpliacaoService
        .getAfericaoAmpliacao(id)
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          })
        )
        .subscribe({
          next: (response: any) => {
            this.afericao = response;
          },
          error: (erro: any) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          },
        })
    );
  }
  onSubmit(assign?:boolean) {
    const formatDataAssinantes = this.dataSource.data.map((item: any) => {
      const newItem = {
        idUsuario: item.user.id,
        idCargo: item.cargo.id
      }
      return item = newItem;
    });


    const comprovacaoData = {
      comentario: this.comentarios,
      autoAssinar: assign ? assign : false,
      arquivos: this.filesAdded.map(fileInfo => ({
        nomeArquivo: fileInfo.nomeArquivo,
        tipoMime: fileInfo.tipoMime,
        categoria: fileInfo.categoria,
        subCategoria: fileInfo.subCategoria,
      })),
      usuariosAssinantes: formatDataAssinantes,
      relatoriosContratuaisVinculados: this.relatoriosVinculados.map((item: any) => ({
        idRelatorioContratual: item.id
      }))
    };

    const transicaoStatusRequestData = {
      idExterno: this.idAfericao,
      idStatusAtual: this.idStatusAtual,
      idTransicao: this.transicaoId,
      comprovacao: comprovacaoData
    };
    const formData = new FormData();
    formData.append('request', new Blob([JSON.stringify(transicaoStatusRequestData)], { type: 'application/json' }));

    // anexa cada arquivo real separadamente
    this.filesAdded.forEach((fileInfo, index) => {
      if (fileInfo.objetoOriginal) {
        formData.append(`arquivosComprovacao`, fileInfo.objetoOriginal, fileInfo.nomeArquivo);
      }
    });

    this.loadingService.showLoading();
    if (this.from == 'afericao-inicial') {
      this.afericaoServicoInicialService.postTransicaoStatus(formData).pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      ).subscribe(
        (response: any) => {

          this.toastService.showSuccess('Mudança de status realizada com sucesso');
          this.router.navigate([`afericoes`]);
        },
        (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
          } else {
            this.toastService.showError();
          }
        }
      );
    } else if(this.from == 'afericao-relatorio') {
      this.afericaoRelatorioService.postTransicaoStatus(formData).pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      ).subscribe(
        (response: any) => {

          this.toastService.showSuccess('Mudança de status realizada com sucesso');
          this.router.navigate([`afericoes/relatorios-contratuais`]);
        },
        (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
          } else {
            this.toastService.showError();
          }
        }
      );
    }else if(this.from == 'afericao-operacional'){
      this.afericaoOperacionalService.postTransicaoStatus(formData).pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      ).subscribe(
        (response: any) => {

          this.toastService.showSuccess('Mudança de status realizada com sucesso');
          this.router.navigate([`afericoes/relatorios-operacionais`]);
        },
        (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
          } else {
            this.toastService.showError();
          }
        }
      );
    }else if(this.from == 'afericao-ampliacao'){
      this.afericaoAmpliacaoService.postTransicaoStatus(formData).pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      ).subscribe(
        (response: any) => {

          this.toastService.showSuccess('Mudança de status realizada com sucesso');
          this.router.navigate([`acompanhamentos/servicos-ampliacao`]);
        },
        (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
          } else {
            this.toastService.showError();
          }
        }
      );
    }

  }
  onSubmitAndAssign(){
    this.openDialogAssinar()
  }
  openDialogAssinar(): void {;

    this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onSignModalConfirm.bind(this),
        modalTitle: 'Confirmação de Assinatura Digital',
        modalContent: 'Você está prestes a assinar digitalmente este documento. Deseja continuar?',
        btnSaveLabel: 'Confirmar Assinatura'
      }
    });
  }

  // === CONFIRMAÇÃO DE ASSINATURA ===
  onSignModalConfirm(): void {
    this.onSubmit(true);
  }

  private handleRequestError(erro: any): void {
    if (erro.status !== 500 && erro.status) {
      this.openSnackBar(erro.error.message, 'error');
    } else if (erro.error?.error === 'Unprocessable Entity') {
      this.openSnackBar(erro.error.message, 'warning');
    } else {
      this.openSnackBar(
        'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
        'error'
      );
    }
  }

  onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (!input.files) return;

        const filesToProcess = Array.from(input.files);

        // 1. Itera sobre os arquivos selecionados
        filesToProcess.forEach((file) => {
            // Obtém a extensão do arquivo e converte para minúsculas
            const fileExtension = file.name.split('.').pop()?.toLowerCase();

            // 2. **Validação do Formato do Arquivo**
            if (!fileExtension || !this.VALID_EXTENSIONS.includes(fileExtension)) {
                // Formato inválido: exibe o toast de erro e PARA o processamento deste arquivo.
                const validFormatsString = this.VALID_EXTENSIONS.map(ext => ext.toUpperCase()).join(' | ');

                // Mensagem de erro mais específica
                this.toastService.showError(`O arquivo "${file.name}" possui um formato inválido. Formatos válidos: ${validFormatsString}.`);

                // Opcional: Se desejar, pode limpar o input de arquivo após a seleção para permitir que o usuário tente novamente
                if (input) {
                    input.value = '';
                }
                return; // Pula para o próximo arquivo se for o caso de seleção múltipla, ou simplesmente sai da função se for uma única seleção inválida.
            }

            // 3. Processamento do arquivo (apenas se for válido)
            const reader = new FileReader();

            reader.onload = () => {
                const fileUrl = reader.result as string;

                if (file.type.startsWith('image')) {
                    // Lógica para imagens
                    this.imagens.push({ fileUrl: fileUrl, fileName: file.name });
                    this.organizeImages();
                } else {
                    // Lógica para outros documentos
                    this.arquivos.push(file.name);
                    this.organizeDocuments();
                }
                let cnpjFormatado = this.formatUtilsService.formatCnpj(this.entitie.cnpj)
                const cnpjSemFormatacao = cnpjFormatado ? cnpjFormatado.replace(/\D/g, '') : '';

                this.filesAdded.push({
                    nomeArquivo: file.name,
                    // Garante que o tipoMime seja a extensão ou o subtipo. O 'split' é usado para o caso de "tipo/subtipo"
                    tipoMime: fileExtension,
                    categoria: 'cadastro_contrato',
                    subCategoria: cnpjSemFormatacao,
                    objetoOriginal: file,
                });
            };

            reader.readAsDataURL(file);
        });

        // Opcional: Limpa o input de arquivo após processar (para permitir o re-upload do mesmo arquivo)
        if (input) {
            input.value = '';
        }
  }

  private organizeImages(): void {
    this.firstLine = this.imagens.slice(0, 4);
    this.secondtLine = this.imagens.slice(4, 8);
  }

  private organizeDocuments(): void {
    this.updateDocumentView();
  }
  getEntity(id: any) {
    this.loadingService.showLoading();
    this.subsctiptions.push(
      this.documentoComprovacaoService
        .getEntidadeAfericao(this.idEntidade)
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          })
        )
        .subscribe({
          next: (response: any) => {
            this.entitie = response;
            this.loadUserInfo();
          },
          error: (erro: any) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError('Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.');
            }
          },
        })
    );
  }
  reset() {
    this.files = [];
    this.imageIndex = 0;
    this.comentario = '';
  }
  private updateImageLines(): void {
    const start = this.imagePageIndex * this.imagesPerPage;
    const pageImages = this.imagens.slice(start, start + this.imagesPerPage);

    this.firstLine = pageImages.slice(0, 4);
    this.secondtLine = pageImages.slice(4, 8);
  }
  prevImages(): void {
    if (this.imagePageIndex > 0) {
      this.imagePageIndex--;
      this.updateImageLines();
    }
  }

  nextImages(): void {
    const maxPages = Math.ceil(this.imagens.length / this.imagesPerPage);
    if (this.imagePageIndex < maxPages - 1) {
      this.imagePageIndex++;
      this.updateImageLines();
    }
  }
  private updateDocumentView(): void {
    const start = this.documentPageIndex * this.documentsPerPage;
    this.documentsForView = this.arquivos.slice(start, start + this.documentsPerPage);
  }
  prevDocuments(): void {
    if (this.documentPageIndex > 0) {
      this.documentPageIndex--;
      this.updateDocumentView();
    }
  }

  nextDocuments(): void {
    const maxPages = Math.ceil(this.arquivos.length / this.documentsPerPage);
    if (this.documentPageIndex < maxPages - 1) {
      this.documentPageIndex++;
      this.updateDocumentView();
    }
  }
  get imageFiles(): UploadedFile[] {
    return this.files.filter(f => f.isImage);
  }

  get otherFiles(): UploadedFile[] {
    return this.files.filter(f => !f.isImage);
  }
  reiniciar(): void {
    this.imagens = [];
    this.arquivos = [];
    this.filesAdded = [];
  }
  getData(pageIndex: number = 0) {

  }
  onSortChange(sortProperty: any): void {
    if (this.sortState.sortProperty === sortProperty) {
      this.sortState.sortDirection =
        this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortState.sortProperty = sortProperty;
      this.sortState.sortDirection = 'asc';
    }
    this.getData();
  }
  pageChangeEvent(event: PageEvent) {
    if (this.pageSize !== event.pageSize) {
      this.pageSize = event.pageSize;
      this.pageSizeService.setPageSize(event.pageSize);
      return this.getData(0);
    }

    if (this.pageIndex !== event.pageIndex) {
      return this.getData(event.pageIndex);
    }
  }
  onOptionSelected(event: any) {
    const selectedOption = event.option.value;
    this.selectedOption = selectedOption;
    this.searchControl.setValue(selectedOption.user.nome, { emitEvent: false });
    this.filteredOptions = [];
  }
  addUser() {

    if (!this.selectedOption) {
      this.openSnackBar('Selecione o usuário.', 'warning');
      return;
    }
    const novoElemento = this.selectedOption;
    const dados = this.dataSource.data;

    const existe = dados.some(item => item.user.id === novoElemento.user.id);

    if (existe) {
      this.openSnackBar('Usuário já adicionado anteriormente.', 'warning');
      return;
    }
    this.dataSource.data = [...dados, novoElemento];

    if(this.idUserAssign == this.selectedOption.id){this.isUserAssign = true};
    this.searchControl.setValue('', { emitEvent: false });
    this.selectedOption = null;


  }
  openDeleteDialog(id: any): void {
    const modalTitle: string = 'Excluir';
    const modalContent: string =
      'Você tem certeza que deseja excluir este Usuário?';

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onDeleteModalConfirm.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
        id: id,
      },
    });
  }
  onDeleteModalConfirm(id: any): void {
    const dados = this.dataSource.data;

    // Verifica se o elemento existe
    const existe = dados.some(item => item.id === id);

    if (!existe) {
      this.openSnackBar('Usuário não encontrado.', 'warning');
      return; // Impede a exclusão
    }

    // Remove o elemento e atualiza o dataSource
    this.dataSource.data = dados.filter(item => item.id !== id);
    if(this.idUserAssign == id ){this.isUserAssign = false};
    this.openSnackBar('Usuário deletado com sucesso.', 'sucess');
  }
  openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'sucess':
        classSnack = 'snacbar-sucess';
        break;
      case 'warning':
        classSnack = 'snacbar-warning';
        break;
      case 'error':
        classSnack = 'snacbar-error';
        break;
    }
    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
  cancel() {
    if (this.from == 'afericao-inicial') {
      this.router.navigate([`afericoes`]);
    } else if (this.from == 'afericao-ampliacao') {
      this.router.navigate([`acompanhamentos/servicos-ampliacao`]);
    } else if (this.from == 'afericao-operacional') {
      this.router.navigate([`afericoes/relatorios-operacionais`]);
    } else {
      this.router.navigate([`afericoes/relatorios-contratuais`]);
    }

  }
  openModalVincular() {
    const dialogRef = this.dialog.open(ModalVincularRelatorioComponent, {
      width: '700px',
      data: {
        dataSource: this.relatoriosVinculados
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.relatoriosVinculados = result;
      }
    });
  }
  onDelete(item: any) {
    this.relatoriosVinculados = this.relatoriosVinculados.filter((i: any) => i.id !== item.id);
  }
  removeImg(img: any) {
    this.imagens = this.imagens.filter((photo: any) => photo.fileName != img.fileName);
    this.filesAdded = this.filesAdded.filter((arq: any) => arq.nomeArquivo != img.fileName);
    this.organizeImages();
  }
  removeFile(file: any) {
    this.arquivos = this.arquivos.filter((arq: any) => arq != file);
    this.filesAdded = this.filesAdded.filter((arq: any) => arq.nomeArquivo != file);
    this.organizeDocuments();
  }
}
